class SortBy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => this.updateSortElements(event));
    this.defaultSortBy = this.getAttribute('data-sort-by-default');
  }

  /**
   * Update sort elements
   * @param {Object} event - Change event
   * @param {Object} event.target - Change event target
   *
   * @description Update all collection sort elements when the sort is changed
   */
  updateSortElements({ target: { value } }) {
    this.sortElements = this.sortElements || document.querySelectorAll('sort-by');

    // The 'element' variable is the current collection sort element. E.g. <sort-by>
    this.sortElements.forEach((element) => {
      // Find the sort-select element
      const select = element.querySelector('select');
      if (select) {
        select.value = value;
      }

      // Find the radio elements
      const radio = element.querySelectorAll(`input[type="radio"][value="${value}"]`);
      if (radio) {
        radio.forEach((radio) => {
          radio.checked = true;
        });
      }
    });

    // Update the URL hash
    this.updateURL(value);

    publish('sort:changed', {
      value,
    });
  }

  /**
   * Update URL
   * @param {String} value - URL value
   */
  updateURL(value) {
    const { searchParams } = new URL(window.location);
    searchParams.set('sort_by', value);

    // if value = default, remove the sort_by parameter from the URL
    if (this.defaultSortBy && value === this.defaultSortBy) {
      searchParams.delete('sort_by');
    }

    const base = searchParams.size
      ? `${window.location.pathname}?${searchParams}`
      : window.location.pathname;
    const newUrl = base + (window.location.hash || '');
    history.replaceState(null, '', newUrl);
  }
}

customElements.define('sort-by', SortBy);
